<template>
  <div style="text-align: left">

    <el-row :gutter="20">
      
      <el-col :span="16">
        <div class="grid-content bg-purple">
          <h2>Welcome to Sebastian's Lab!</h2>
          The mission of our lab is to develop and apply technologies for global health and global development problems.</br> </br>
          The vision of our lab is to address problems of global relevance by challenging paradigmes and shattering disciplinary barriers.
          <div>
          <img src="../../assets/home1.png" style="width: 100%;height: auto;margin-top: 12px;" />  
          </div>
        </div>
      </el-col>

        <el-col :span="8">
        <div class="grid-content bg-purple">
          <h2>News</h2>
          <News />
        </div>
      </el-col>
    </el-row>


 
  
  </div>
</template>


<script>
  import News from './home/News';

  export default {
    data() {
      return {
        
      };
    },
    methods: {},
    components: {
      News
    }
  };
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/content/Home.vue